/**
 * Port_Api form endpoint'leri:
 *   POST /api/applications  (multipart: firstName, lastName, email, phone?, message?, cv)
 *   POST /api/contact       (JSON: firstName, lastName, email, phone?, subject?, message)
 */

const API_BASE =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:5194/api';

export type FormSuccess = { success: boolean; id?: number };

export type ContactPayload = {
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  subject?: string;
  message: string;
};

async function readErrorMessage(response: Response, fallback: string) {
  try {
    const body = await response.json();
    if (body && typeof body.message === 'string' && body.message.trim()) {
      return body.message;
    }
  } catch {
    // yut
  }
  return fallback;
}

async function postJson<T>(path: string, data: unknown): Promise<T> {
  let response: Response;
  try {
    response = await fetch(`${API_BASE}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
  } catch {
    throw new Error('Sunucuya bağlanılamadı. Lütfen daha sonra tekrar deneyin.');
  }

  if (!response.ok) {
    throw new Error(await readErrorMessage(response, 'İşlem başarısız. Lütfen tekrar deneyin.'));
  }

  return (await response.json()) as T;
}

async function postFormData<T>(path: string, data: FormData): Promise<T> {
  let response: Response;
  try {
    // Content-Type bilinçli verilmez; browser multipart boundary ekler
    response = await fetch(`${API_BASE}${path}`, {
      method: 'POST',
      body: data,
    });
  } catch {
    throw new Error('Sunucuya bağlanılamadı. Lütfen daha sonra tekrar deneyin.');
  }

  if (!response.ok) {
    throw new Error(await readErrorMessage(response, 'İşlem başarısız. Lütfen tekrar deneyin.'));
  }

  return (await response.json()) as T;
}

/** Kariyer / CV basvurusu — Port_Api POST /api/applications */
export function submitApplication(data: FormData) {
  return postFormData<FormSuccess>('/applications', data);
}

/** Iletisim formu — Port_Api POST /api/contact */
export function submitContact(data: ContactPayload) {
  return postJson<FormSuccess>('/contact', data);
}
